(function() {
'use strict';
angular
    .module('core')
    .directive('baseStaticMap', baseStaticMap);

const template = `
    <div>
        <lightbox class="lightbox-map" show="showModal" close="close()">
            <div class="map-canvas" style="z-index: 1"> </div>
        </lightbox>
    </div>
`;

function baseStaticMap(
    $window,
    $compile,
    $rootScope,
    currentDestination,
    mapLabel,
    broker,
    hotelRehydrator,
    hotelStaticMapService,
    maps
) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            zoom: '=',
            hideLabels: '@'
        },
        template,
        link(scope, el) {
            maps.loadScript(_.bind(_linker, {}, scope, el));
        }
    };

    function _linker(scope, el) {
        scope.ready = true;

        const Label = mapLabel($window.google);
        const infoWindow = new google.maps.InfoWindow();
        const labels = [];

        currentDestination.getCurrentDestination().then(destination => {
            broker.subscribe('hotelStaticMap', 'MAPLIGHTBOX', _.bind(buildMap, {}, destination));

            scope.$on('$destroy', function() {
                broker.unsubscribe('hotelStaticMap');
            });
        });

        function buildMap(destination) {
            scope.showModal = true;
            scope.close = () => {
                scope.showModal = false;
            };

            const map = new google.maps.Map(el.find('.map-canvas')[0], {
                zoom: scope.zoom || destination.ZoomLevel,
                scrollwheel: true,
                overviewMapControl: false,
                center: new google.maps.LatLng(
                    destination.Latitude,
                    destination.Longitude
                ),
                mapTypeControl: false,
                streetViewControl: true,
                scaleControl: true
            });

            google.maps.event.addListenerOnce(map, 'idle', () => {
                setTimeout(() => {
                    google.maps.event.trigger(map, 'resize');
                    map.setCenter(new google.maps.LatLng(
                        destination.Latitude,
                        destination.Longitude
                    ));
                }, 500);
            });

            google.maps.event.addListener(map, 'idle', () => {
                const zoom = map.getZoom();
                const loadedBounds = map.getBounds();
                const sw = loadedBounds.getSouthWest();
                const ne = loadedBounds.getNorthEast();
                const url = `?X1=${sw.lng()}&Y1=${sw.lat()}&X2=${ne.lng()}&Y2=${ne.lat()}&Z=${zoom}`;

                hotelStaticMapService.getMarkers(url).then(res => {
                    if (scope.hideLabels !== 'true') {
                        _clearLabels();
                        generateLabels(res.data.Markers, map);
                    }
                });
            });
        }

        function generateLabels(points, map) {
            for (let i = 0, ii = points.length; i < ii; i++) {
                const p = points[i];
                const key = _getKey(p);
                const markerLabel = new Label({
                    map,
                    visible: true,
                    position: new google.maps.LatLng(p.Y, p.X, true),
                    text: p.N
                }, key, p.N);

                markerLabel.clickHandler =
                    p.N === 1 ?
                    _.bind(hotelClickHandler, markerLabel, p.Id, map) :
                    _.bind(clusterClickHandler, markerLabel, p, map);

                labels.push(markerLabel);
            }
        }

        function clusterClickHandler(point, map) {
            const sw = new google.maps.LatLng(point.B.Y1, point.B.X1);
            const ne = new google.maps.LatLng(point.B.Y2, point.B.X2);
            const bds = new google.maps.LatLngBounds(sw, ne);
            map.fitBounds(bds);
        }

        function hotelClickHandler(estabId, map) {
            infoWindow.close();
            infoWindow.setContent('<div class="hotel-info-window-loader"> </div>');
            infoWindow.open(map, this);
            hotelRehydrator.hotel(estabId).then(h => {
                const t = '<info-window></info-window>';
                const s = $rootScope.$new(true);

                s.hotel = h;
                infoWindow.setContent($compile(t)(s)[0]);
            });
        }

        function _clearLabels() {
            for (let i = 0, ii = labels.length; i < ii; i++) {
                labels[i].visible = false;
            }
            labels.length = 0;
            broker.publish('CHANGEDLABELVISIBILITY');
        }

        function _getKey(point) {
            return `${point.X}__${point.Y}__${point.N}__${point.T}`.replace(/\./g, '_');
        }
    }
}
})();
